import React, { useEffect, useState } from "react";
import CommonButton from "../../../reusable/Button";
import DeliverAddress from "./DeliverAddress";
import { getFromLocalStorage } from "../../../helpers";
import { useForm } from "react-hook-form";
import FormInput from "../../../reusable/CustomInput/formInput";
import allCountries from "../../../assets/constants/country-state-city/country.json";
import SelectOptionsInput from "../../../reusable/selectOptionInput";
import { useDispatch, useSelector } from "react-redux";
import { address } from "../../../reducers/users/order";
import { getCountryStates, getStateCity } from "../../../api/common";

const AddressDetails = ({ changeAddressHandler }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const token = getFromLocalStorage("token");
  const {
    register,
    unregister,
    formState: { errors },
    handleSubmit,
    setError,
    setValue,
    reset,
  } = useForm();
  const item = useSelector((state) => state.order.address);
  const { allAddressList } = useSelector((state) => state.common);
  const [statesList, setStatesList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    if (token && !item?.customerPhone)
      dispatch(address(allAddressList?.data?.userAddress[0]));
  }, [allAddressList?.data?.userAddress]);

  const compare = (a, b) => {
    if (a.name < b.name) return -1;
    if (a.name > b.name) return 1;
    return 0;
  };

  const handleOptionCLick = (e) => {
    const { value, name } = e.target;
    if (name === "country") {
      setValue("state", null);
      setValue("city", null);
      setStatesList([]);
      setCityList([]);
      let obj = {
        countryCode: value,
      };
      localStorage.setItem("countryCode", value);
      dispatch(getCountryStates(obj))
        .then((res) => {
          setStatesList(res?.data);
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
    if (name === "state") {
      setLoading(true);
      setValue("city", null);
      setCityList([]);
      let obj = {
        countryCode: localStorage?.countryCode,
        stateCode: value,
      };
      dispatch(getStateCity(obj))
        .then((res) => {
          setCityList(res?.data);
          setLoading(false);
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
  };

  const onFormSubmit = (item) => {
    localStorage.setItem("address", JSON.stringify(item));
    setModalVisible(false);
  };

  useEffect(() => {
    const data = JSON.parse(localStorage.address || "{}");
    const fetchData = async () => {
    };
    fetchData();
    if (localStorage.address) {
      setValue("customerName", data?.customerName);
      setValue("customerPhone", data?.customerPhone);
      setValue("pinCode", data?.pinCode);
      // setValue("locality", data?.locality);
      setValue("country", data?.country);
      setValue("state", data?.state);
      setValue("city", data?.city);
      setValue("alternatePhone", data?.alternatePhone);
      // setValue("landMark", data?.landMark);
      setValue("address", data?.address);
      setValue("customerEmail", data?.customerEmail);
      // const statesData = State.getStatesOfCountry(data?.country);
      // setStatesList(statesData);
    }
  }, [localStorage.address]);

  const randerModal = () => {
    if (modalVisible) {
      return (
        <div
          className={`modal fade  show d-block`}
          id="thankyou"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex={-1}
          aria-labelledby="thankyouLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div
              className="modal-content  ad-bg-cyan px-2 "
              style={{ width: "600px" }}
            >
              <div className="modal-header d-flex justify-content-between">
                <div className="modal-title " id="exampleModalLabel">
                  <h5>Add New Address</h5>
                  <h5></h5>
                </div>

                <button
                  type="button"
                  className="btn-close ad-text-primary mx-2"
                  onClick={() => setModalVisible(false)}
                ></button>
              </div>
              <div className="modal-body mx-3">
                <form onSubmit={handleSubmit(onFormSubmit)}>
                  <div className="row my-4">
                    <div className="col-md-6 mb-3">
                      <div className="custom_icon_input position-relative margin_above ">
                        <FormInput
                          label={"Name"}
                          type="text"
                          className="form-control"
                          placeholder="Name"
                          register={register}
                          name="customerName"
                          rule={{ required: "This field is required!" }}
                          error={errors?.customerName ? true : false}
                          errorMessage={errors?.customerName?.message}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="custom_icon_input position-relative margin_above ">
                        <FormInput
                          label={"Email"}
                          type="email"
                          className="form-control"
                          placeholder="Email"
                          register={register}
                          name="customerEmail"
                          rule={{ required: "This field is required!" }}
                          error={errors?.customerEmail ? true : false}
                          errorMessage={errors?.customerEmail?.message}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="custom_icon_input position-relative margin_above">
                        <FormInput
                          label={"Phone Number"}
                          type="number"
                          className="form-control"
                          placeholder="Phone Number"
                          register={register}
                          name="customerPhone"
                          rule={{ required: "This field is required!" }}
                          error={errors?.customerPhone ? true : false}
                          errorMessage={errors?.customerPhone?.message}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 mb-3 ">
                      <div className="custom_icon_input position-relative margin_above">
                        <FormInput
                          label={"Postal code"}
                          type="text"
                          className="form-control"
                          placeholder="Postal code"
                          register={register}
                          name="pinCode"
                          rule={{ required: "This field is required!" }}
                          error={errors?.pinCode ? true : false}
                          errorMessage={errors?.pinCode?.message}
                        />
                      </div>
                    </div>
                    {/* <div className="col-md-6 mb-3">
                      <div className="custom_icon_input position-relative margin_above">
                        <FormInput
                          label={"Locality"}
                          type="text"
                          className="form-control"
                          placeholder="Locality"
                          register={register}
                          name="locality"
                          rule={{ required: "This field is required!" }}
                          error={errors?.locality ? true : false}
                          errorMessage={errors?.locality?.message}
                        />
                      </div>
                    </div> */}
                    <div className="col-md-6 mb-3 ">
                      <div className="custom_icon_input position-relative margin_above">
                        <SelectOptionsInput
                          label={"Country"}
                          error={errors?.country ? true : false}
                          errorMessage={errors?.country?.message}
                          options={allCountries}
                          name="country"
                          selectedValue={"Select Country"}
                          onOptionClick={handleOptionCLick}
                          {...register("country", { required: true })}
                        />
                      </div>
                    </div>

                    <div className="col-md-6 mb-3">
                      <div className="custom_icon_input position-relative margin_above">
                        <SelectOptionsInput
                          label={"State"}
                          error={errors?.state ? true : false}
                          errorMessage={errors?.state?.message}
                          options={statesList}
                          name="state"
                          onOptionClick={handleOptionCLick}
                          selectedValue={"Select State"}
                          {...register("state", { required: true })}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 mb-3 ">
                      {loading ? (
                        <div style={{ margin: "0", padding: "0" }}>
                          <label>City</label>
                          <div className="form-control d-flex justify-content-between">
                            <h6 style={{ fontWeight: "100" }}>Select City</h6>
                            <div
                              className="spinner-border text-primary"
                              role="status"
                            ></div>
                          </div>{" "}
                        </div>
                      ) : (
                        <div className="custom_icon_input position-relative margin_above">
                          <SelectOptionsInput
                            label={"City"}
                            error={errors?.city ? true : false}
                            errorMessage={errors?.city?.message}
                            options={cityList}
                            name="city"
                            selectedValue={"Select City"}
                            {...register("city", { required: true })}
                          />
                        </div>
                      )}
                    </div>
                    <div className="col-md-6 mb-3 ">
                      <div className="custom_icon_input position-relative margin_above">
                        <FormInput
                          label={"Alternate Number"}
                          type="text"
                          className="form-control"
                          placeholder="Alternate Number"
                          register={register}
                          name="alternatePhone"
                          rule={{}}
                          error={errors?.alternatePhone ? true : false}
                          errorMessage={errors?.alternatePhone?.message}
                        />
                      </div>
                    </div>
                    {/* <div className="col-md-6 mb-3 ">
                      <div className="custom_icon_input position-relative margin_above">
                        <FormInput
                          label={"Landmark"}
                          type="text"
                          className="form-control"
                          placeholder="Landmark"
                          register={register}
                          name="landMark"
                          rule={{ required: "This field is required!" }}
                          error={errors?.landMark ? true : false}
                          errorMessage={errors?.landMark?.message}
                        />
                      </div>
                    </div> */}
                    <div className="col-md-12 ">
                      <div className="custom_icon_input position-relative margin_above">
                        <FormInput
                          label={"Address"}
                          rows="3"
                          id="pre_requisites"
                          name="address"
                          placeholder="Address (Area and Street) "
                          textArea="true"
                          height="140px"
                          register={register}
                          rule={{ required: "This field is required!" }}
                          error={errors?.address ? true : false}
                          errorMessage={errors?.address?.message}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="text-center mb-3">
                    <button
                      type="submit"
                      className="ad-bg-primary btn ms-2 ad-text-secondary"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      );
    }
  };

  return (
    <div className="form-control my-4 py-2">
      <div className="row">
        <div className="col-md-12 align-self-center ">
          <div className="d-flex justify-content-between align-items-center  ">
            <h6 className="">To Delivered</h6>

            {token ? (
              <CommonButton
                type="submit"
                className="button outlined px-4 rounded-1 my-2   "
                onClick={changeAddressHandler}
              >
                <span>Change Address</span>
              </CommonButton>
            ) : (
              <CommonButton
                type="submit"
                className="button outlined px-4 rounded-1 my-2   "
                onClick={() => setModalVisible(true)}
              >
                <span>
                  {localStorage.address ? "Edit Address" : "Add Address"}
                </span>
              </CommonButton>
            )}
          </div>
        </div>
        <div className="col-md-12">
          <DeliverAddress
            item={token ? item : JSON.parse(localStorage.address || "{}")}
            hide={true}
          />
          {/* </div> */}
        </div>
      </div>
      {randerModal()}
    </div>
  );
};

export default AddressDetails;
